import { render, staticRenderFns } from "./EditPageDetailsSEO.vue?vue&type=template&id=893b701a&"
import script from "./EditPageDetailsSEO.vue?vue&type=script&lang=js&"
export * from "./EditPageDetailsSEO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports